module.exports = __webpack_public_path__ + "static/media/bg.788eaf90.png";